import { customAxios } from '../../axios/CustomAxios';
import {myIpAddress} from "../../config";

// 카테고리 코드맵
const allCommonCodeCategoryMap =()=>{
    return customAxios.post(myIpAddress+'/commonCode/allCommonCodeCategoryMap',);
}
export default allCommonCodeCategoryMap;